<div class="row">
  <div class="col-12" *ngIf="latestFiles.length">
    <br />
    <h3>{{ 'Uppladdade filer' | translate }}</h3>
    <table class="fullwidth styled">
      <tr *ngFor="let file of latestFiles">
        <td>
          {{file.fileName}}
        </td>
        <td class="align-right">
          <button mat-raised-button color="primary" (click)="copySKU(file.fileName)">
            <ng-container *ngIf="file.fileName != copiedFileName"><mat-icon>content_paste</mat-icon> {{ 'Kopiera SKU' | translate }}</ng-container>
            <ng-container *ngIf="file.fileName == copiedFileName"><mat-icon>check</mat-icon> {{ 'Kopierad!' | translate }}</ng-container>
          </button>
        </td>
      </tr>
    </table>
  </div>

  <div class="col-12" *ngIf="latestPosters.length">
    <br />
    <h3>{{ 'Skapade posters' | translate }}</h3>
    <table class="fullwidth styled">
      <tr *ngFor="let poster of latestPosters">
        <td>
          <a [routerLink]="[globals.panelUrl('/posters/' + poster._id)]">{{poster.name}}</a>
        </td>
        <td class="align-right">

        </td>
      </tr>
    </table>
  </div>

  <div class="col-12">
    <div class="file-upload" [ngClass]="{'uploading': uploading}">
      <div ng2FileDrop [ngClass]="{'file-over': fileOverDropZone}" class="drop-zone" (fileOver)="fileOver($event)"
        (onFileDrop)="fileDropped($event)" [uploader]="uploader">
        <div class="frame clickable" (click)="openFileSelect()">
          <ng-container *ngIf="!createPoster && !posterId">
            <div class="text">
              <h2>{{ 'Släpp filer här' | translate }}</h2>
            </div>

          </ng-container>

          <ng-container *ngIf="createPoster">
            <div class="text">
              <h2>{{ 'Släpp filer här' | translate }}</h2>
            </div>
          </ng-container>

          <ng-container *ngIf="!createPoster && posterId">
            <div class="text">
              <h2>{{ 'Släpp tryckfil för' | translate }} {{printFileSize}} {{ 'här' | translate }}</h2>
              <h3>{{ '(Endast PDF)' | translate }}</h3>
            </div>
          </ng-container>

        </div>
      </div>
      <input type="file" #fileInput ng2FileSelect [uploader]="uploader" style="display: none" />
      <div *ngIf="uploading">
        <h3 *ngIf="!uploadingComplete">{{ 'Laddar upp..' | translate }}</h3>
        <table class="fullwidth styled">
          <tr *ngFor="let file of filesToUpload">
            <td>{{file.name}}</td>
            <td class="align-right">
              <span class="material-symbols-outlined spinning" *ngIf="file.status =='UPLOADING'">sync</span>
              <span class="material-symbols-outlined" *ngIf="file.status =='FAILED'">close</span>
              <span class="material-symbols-outlined" *ngIf="file.status =='FINISHED'">done</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</div>
